<template>
    <div>
        <ais-instant-search :search-client="searchClient" index-name="certified_employers">
            <ais-search-box autofocus placeholder="Search for Employer by any keyword..."></ais-search-box>
            <div class="refinament">
                <ais-refinement-list attribute="status" />
                <ais-toggle-refinement attribute="third_party" label="Third Party"/>
            </div>
            <ais-hits>
                <table class="table table-striped table-hover mb-3" slot-scope="{ items }">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Company</th>
                        <th>County</th>
                        <th>Certified Number</th>
                        <th>Status</th>
                        <th>Code</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="user in items" :key="user.objectID" class="clickleable" @click="selectUser(user)">
                        <td v-text="user.name"></td>
                        <td v-text="user.company"></td>
                        <td v-text="user.county"></td>
                        <td v-text="user.number"></td>
                        <td class="hidden-xs text-center">
                        <span v-if="user.active">
                            <i class="fa fa-star" style="color: orange;" :title="user.status"></i>
                            <small class="text-muted" >Active</small>
                        </span>
                            <span v-else>
                            <i class="fa fa-star-o text-muted" :title="user.status"></i>
                            <small class="text-muted">Inactive</small>
                        </span>
                        </td>
                        <td v-text="user.year"></td>
                    </tr>
                    </tbody>
                </table>
            </ais-hits>
            <ais-pagination />
        </ais-instant-search>
    </div>
</template>

<script>

    import algoliasearch from "algoliasearch/lite";
    let CertificationTable = require('@/mixins/CertificationTable');

    export default {

        mixins: [CertificationTable],

        data() {
            return {
                searchClient: null,
            };
        },

        created(){
            let key = App.config.debug ? '8V0EEYLJXS' : '00ZJ8IEWB4';
            var secret = App.config.debug ? '973738e5a20df317095d397dd66d6d05' : 'af28db7463252bd80825c8986daa5302';
            this.searchClient = algoliasearch(key, secret)
        }
    };
</script>